module.exports = __webpack_public_path__ + "static/media/nav-login.3152e77a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/nav-login.svg
 ** module id = 1313
 ** module chunks = 0
 **/